import { useEffect, useRef, useState } from "react";
import { useApiCall } from "../context/SnpApiContext";
import "../css/SnpChatApp.css";
import ChatToast from "./ChatToast";
import SnpChatWidget from "./SnpChatWidget";
import { getMsgFrom, isEmptyData, printChatDebugLog } from "../utils/SnpChatUtils";
import { CHATSOCKETERROR, Direction, InternalAddRemoveChannel, ToneType, WhichMessage } from "../utils/SnpChatConstant";

const SnpChatAdminWidget = ({
    selectedChat,
    toast,
    setToast,
    handleCustomToastFunc,
    removeChatItemFromList,
    handleAddRemoveItemCallback,
    chatSocketHandlers,
    setChatSocketHandlers,
    chatAdminHead,
    setChatAdminHead,
    setShowImageView,
    closeChat,
    initiateSoundNotification,
    setRefreshChat,
    whoStopped,
    setWhoStopped
}) => {



    const wsSessionConnectingRef = useRef(false);
    const chatAdminHeadRef = useRef(chatAdminHead);
    const chatSocketHandlerRef = useRef(null);

    useEffect(() => {
        printChatDebugLog("ChatContext:chatAdminHead: ", chatAdminHead);
        chatAdminHeadRef.current = chatAdminHead;
    }, [chatAdminHead])

    useEffect(() => {
        chatSocketHandlerRef.current = chatSocketHandlers;
    }, [chatSocketHandlers])



    const {
        keyShopHash,
        keyUserDetails,
        connectWsSession,
        stopWsSession
    } = useApiCall();

    useEffect(() => {
        printChatDebugLog("ChatContext:SnpChatAdminWidget: useEffect keyUserDetails", keyUserDetails, "keyShopHash: ", keyShopHash);
        if (!isEmptyData(keyShopHash) && keyUserDetails && !isEmptyData(keyUserDetails.id)) {
            handleMainSession();
        } else {
            printChatDebugLog("ChatContext:keyUserDetails is empty");
        }
    }, [keyShopHash, keyUserDetails]);


    const registerSocketHandler = (key, handler) => {
        setChatSocketHandlers(key, handler, true);
    };

    const unregisterSocketHandler = (key, fullClear = true) => {
        setChatSocketHandlers(key, null, false);
        if (fullClear) {
            removeChatItemFromList("unregisterSocketHandler", key, false);
            closeChat();
            setRefreshChat(true);
        }
    };

    const handleMainSession = () => {
        if (!wsSessionConnectingRef.current) {
            wsSessionConnectingRef.current = true;
            handleWsSession();
        } else {
            printChatDebugLog("ChatContext:handleMainSession:", "already trying connect");
        }
    }


    const handleWsSession = () => {
        printChatDebugLog("ChatContext:SnpChatAdminWidget: ", "handleWsSession");
        connectWsSession(keyUserDetails.id, true, handleCustomToastFunc, (isOpen) => {
            wsSessionConnectingRef.current = false;
            if (isOpen) {
                handleCustomToastFunc("handleWsSession", "Chat Session Established ... ", false);
            } else {
                handleCustomToastFunc("handleWsSession", "Chat Session Close/Disconnected", true);
            }
        }, (response, snpModel) => {
            if (snpModel) {
                printChatDebugLog("ChatContext:ChatAdmin:handleWsSession", response);
                const chatPayload = response.payLoad;
                if (chatPayload.whichMessage === WhichMessage.BROADCAST_NEW_CHAT_SESSION) {
                    const chat = {
                        message: chatPayload.message,
                        messageFrom: chatPayload.msgFrom,
                        messageType: chatPayload.messageType,
                        sessionId: chatPayload.sessionId,
                        msgAt: chatPayload.msgAt,
                    }
                    handleAddRemoveItemCallback(InternalAddRemoveChannel.Receive_Chat_Add, chat);
                    handleCustomToastFunc("BROADCAST_NEW_CHAT_SESSION", "New Message Received", false, ToneType.New_Chat_Receive);
                } else if (chatPayload.whichMessage === WhichMessage.BROADCAST_CHAT_DESTINATION_JOINED) {
                    removeChatItemFromList("BROADCAST_CHAT_DESTINATION_JOINED", chatPayload.sessionId, true);
                } else if (chatPayload.whichMessage === WhichMessage.BROADCAST_CHAT_ERROR) {
                    stopWsSession();
                    if (response.status === CHATSOCKETERROR) {
                        const errMsg = response.errorMessage;
                        if (isEmptyData(errMsg)) {
                            printChatDebugLog("ChatContext:CHATSOCKETERROR ", "errorMessage is empty");
                            errMsg = "Error Connecting Chat Engine .... ";
                        }
                        handleCustomToastFunc("CHATSOCKETERROR", errMsg, true, ToneType.Error);
                    }
                } else {
                    handleOnChatSocketMessage(response.status, response.errorMessage, chatPayload.sessionId, chatPayload);
                }
            } else {
                console.log("ChatContext:connectWsSession in message format ", response);
            }
        });
    };

    const popToastFunc = (chatPayload, error, toneType) => {
        const whichMessage = chatPayload.whichMessage || -1;
        let dm = "";
        if (whichMessage === WhichMessage.BROADCAST_CHAT_CLOSED) {
            dm = `Session Stopped(${chatPayload.stopBy}),clearing all data`;
        } else {
            const msgFrom = chatPayload.msgFrom;
            const message = chatPayload.message;
            if (!isEmptyData(msgFrom)) {
                dm = `${msgFrom}: `;
            }
            if (!isEmptyData(message)) {
                dm = `${dm}${message}`;
            }
        }
        printChatDebugLog("ChatContext:popToastFunc", dm);
        if (!isEmptyData(dm)) {
            handleCustomToastFunc("popToastFunc", dm, error, toneType);
        }
    }

    const handleOnChatSocketMessage = (status, errorMessage, sessionId, chatPayload) => {
        const localChatRefChatHandler = chatSocketHandlerRef.current;
        if (localChatRefChatHandler !== null && !isEmptyData(sessionId)) {
            let popupCall = false;
            const onChatSocketMessageFunc = localChatRefChatHandler.get(sessionId);
            if (onChatSocketMessageFunc) {
                onChatSocketMessageFunc(status, errorMessage, chatPayload);
                popupCall = !chatAdminHeadRef.current;
            } else {
                popupCall = true;
            }
            if (popupCall) {
                printChatDebugLog("ChatContext:handleOnChatSocketMessage", chatPayload)
                popToastFunc(chatPayload, false, ToneType.New_Chat_Receive);
            }
            if (chatPayload.whichMessage === WhichMessage.MESSAGE_DATA) {
                const runningReceiveChatMsg = {
                    sessionId: chatPayload.sessionId,
                    msgAt: chatPayload.msgAt,
                    messageFrom: chatPayload.msgFrom,
                    messageType: chatPayload.messageType,
                    message: chatPayload.message,
                };
                handleAddRemoveItemCallback(InternalAddRemoveChannel.Running_Recive_Chat_Replace, runningReceiveChatMsg);
            }
        } else {
            console.warn("ChatContext:handleOnChatSocketMessage", "No Chats on Head(Impossible");
        }
    };


    return (
        <>
            {(selectedChat) && (
                <div className="chat-widget-container">
                    <div key={selectedChat.sessionId} className="chat-widget-box">
                        <SnpChatWidget
                            sessionId={selectedChat.sessionId}
                            mUserDetails={keyUserDetails}
                            viaAdmin={true}
                            registerSocketHandler={registerSocketHandler}
                            unregisterSocketHandler={unregisterSocketHandler}
                            setChatAdminHead={setChatAdminHead}
                            showImageView={setShowImageView}
                            initiateSoundNotification={initiateSoundNotification}
                            setRefreshChat={setRefreshChat}
                            whoStopped={whoStopped}
                            setWhoStopped={setWhoStopped}
                        />
                    </div>
                </div>
            )}
            {toast && (
                <ChatToast
                    type={toast.type}
                    message={toast.message}
                    duration={3000}
                    onClose={() => setToast(null)}
                />
            )}


        </>
    );
};


export default SnpChatAdminWidget;